/** A link's weekly availability in one line, for the Screening links folder (Oct 24 2026). */
import type { LinkInterviewer } from '../../services/interviewLinksApi';

const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
const DAY_LABEL: Record<(typeof DAYS)[number], string> = {
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
};

/**
 * "Mon–Fri 09:00–17:00", or one entry per run of days that share their windows. Read off the first
 * interviewer — on a screening link that is the owner.
 */
export function availabilitySummary(interviewer?: LinkInterviewer | null): string {
  if (!interviewer) return 'no availability';
  const windowsOf = (d: (typeof DAYS)[number]) =>
    (interviewer.availability?.[d] ?? []).map((w) => `${w.start}–${w.end}`).join(', ');
  const runs: { from: string; to: string; windows: string }[] = [];
  for (const d of DAYS) {
    const windows = windowsOf(d);
    if (!windows) continue;
    const last = runs[runs.length - 1];
    const prev = DAYS[DAYS.indexOf(d) - 1];
    if (last && last.windows === windows && last.to === DAY_LABEL[prev]) last.to = DAY_LABEL[d];
    else runs.push({ from: DAY_LABEL[d], to: DAY_LABEL[d], windows });
  }
  if (!runs.length) return 'no availability';
  return runs.map((r) => `${r.from === r.to ? r.from : `${r.from}–${r.to}`} ${r.windows}`).join(' · ');
}
